import React, { useEffect, useState, useContext } from 'react'
import { DefaultContext } from '../../../context/context_default';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

// import imgBG from "../../../assets/imagens/2.png";
// import imgBG2 from "../../../assets/imagens/97. Thallarsce Quebrador de Realidades.png";

const ItemListDeck = ({ deck, profile = false, onDelete, onLike, showLikeButton = true }) => {
	const {

		causas,
		fortunas,

		listCards,

		usersList,
		globalFirestoreData

	} = useContext(DefaultContext);
	const [card, setCard] = useState(null);
	const [causa, setCausa] = useState(null);
	const [fortunas_finais, setFortunas_finais] = useState(null);
	useEffect(() => {
		if (!listCards || !deck?.matriz) return;

		setCard(listCards?.find(e => e.id == deck.quebrador))

		var matriz = deck.matriz.map(e => e.id)

		var cards_fortunas = listCards?.filter(e => matriz.includes(e.id))
		if (!cards_fortunas || cards_fortunas.length === 0) return;

		var fortunas_id = [];
		var fortunas_fi = [];
		for (let item of cards_fortunas) {
			if (item?.fortuna) {
				fortunas_id.push([...item.fortuna])
			}
		}
		fortunas_id = fortunas_id.flat();
		fortunas_id = fortunas_id?.filter((valor, indice, array) => {
			return array.indexOf(valor) === indice;
		});

		fortunas_fi = fortunas?.filter(e => fortunas_id.includes(e.id))
		setFortunas_finais(fortunas_fi)

	}, [listCards, deck])

	useEffect(() => {
		setCausa(causas?.find(e => e.id == card?.causa))
	}, [card])


	const calcularDiferenca = (data, up) => {

		const milliseconds = data?.seconds * 1000 + Math.round(data?.nanoseconds / 1e6);

		const data1 = new Date(milliseconds);
		const data2 = new Date();

		const diferencaEmMilissegundos = Math.abs(data2 - data1);

		const segundos = Math.floor(diferencaEmMilissegundos / 1000);
		const minutos = Math.floor(segundos / 60);
		const horas = Math.floor(minutos / 60);
		const dias = Math.floor(horas / 24);
		const anos = Math.floor(dias / 365);

		if (anos > 0) {
			return `Criado há ${anos} ${anos !== 1 ? 'anos' : 'ano'}`;
		} else if (dias > 0) {
			return `Criado há ${dias} ${dias !== 1 ? 'dias' : 'dia'}`;
		} else if (horas > 0) {
			return `Criado há ${horas} h`;
		} else if (minutos > 0) {
			return `Criado há ${minutos} min`;
		} else {
			return `Criado há ${segundos} s`;
		}

	};

	const estiloDoComponente = {
		WebkitFilter: 'drop-shadow(0px 0px 1px #000000)',
		filter: 'drop-shadow(0px 0px 1px #000000)',
	};

	const estiloDoComponentFortunasquentes = {
		WebkitFilter: 'drop-shadow(0px 0px 1px #FF5000)',
		filter: 'drop-shadow(0px 0px 1px #FF5000)',

	};
	const estiloDoComponentFortunaslgidas = {
		WebkitFilter: 'drop-shadow(0px 0px 2px #00a0ff)',
		filter: 'drop-shadow(0px 0px 2px #00a0ff)',

	};

	const handleViewDeck = (e) => {
		e.stopPropagation();
		window.open(`/deck/${deck.id}`, '_blank');
	};

	const handleDelete = (e) => {
		e.stopPropagation();
		if (onDelete) {
			onDelete(deck);
		}
	};

	const handleLike = (e) => {
		e.stopPropagation();
		if (onLike) {
			onLike(deck.id);
		}
	};

	const isLiked = deck.likes && globalFirestoreData?.userId ?
		deck.likes.includes(globalFirestoreData?.userId) : false;
	const likesCount = deck.likes ? deck.likes.length : 0;

	return (
		<div style={{ backgroundImage: `url(${card?.url_img})`, backgroundPosition: 'center', backgroundPositionY: -90 }
		} className='bg-slate-600 w-full h-full border border-slate-700 rounded-2xl shadow hover:bg-slate-500 cursor-pointer overflow-hidden relative group transition-all duration-200' >
			{/* Botões que aparecem no hover */}
			<div className='absolute top-12 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 flex flex-col space-y-2'>
				<button
					onClick={handleViewDeck}
					className='bg-slate-600 hover:bg-blue-500 h-8 w-8 rounded-full shadow-lg transition-colors duration-200 flex items-center justify-center'
					title='Ver detalhes do deck'
				>
					<VisibilityIcon className='h-4 w-4 text-white' />
				</button>
				{showLikeButton && onLike && (
					<button
						onClick={handleLike}
						className={`${isLiked ? 'bg-red-500 hover:bg-red-600' : 'bg-slate-600 hover:bg-red-500'} h-8 w-8 rounded-full shadow-lg transition-colors duration-200 flex items-center justify-center`}
						title={isLiked ? 'Remover like' : 'Dar like'}
					>
						{isLiked ?
							<FavoriteIcon className='h-4 w-4 text-white' /> :
							<FavoriteBorderIcon className='h-4 w-4 text-white' />
						}
					</button>
				)}
				{onDelete && (
					<button
						onClick={handleDelete}
						className='bg-slate-600 hover:bg-red-500 h-8 w-8 rounded-full shadow-lg transition-colors duration-200 flex items-center justify-center'
						title='Excluir deck'
					>
						<DeleteIcon className='h-4 w-4 text-white' />
					</button>
				)}
			</div>

			{/* Contador de likes sempre visível */}
			{showLikeButton && likesCount > 0 && (
				<div className='absolute top-10  left-2 bg-red-500 bg-opacity-90 text-white text-xs pr-2 pl-1 py-0 rounded-full flex items-center space-x-1 shadow-lg'>
					<FavoriteIcon className='h-1 w-1' />
					<span className='font-medium'>{likesCount}</span>
				</div>
			)}
			<div className='bg-slate-600 bg-opacity-40 hover:bg-opacity-40 hover:bg-slate-400  w-full h-full'>
				<div className='bg-gradient-to-b from-transparent  to-slate-800 w-full h-full flex flex-col justify-end p-2'>
					<div className='flex justify-between items-center'>< div className='text-xs' >{calcularDiferenca(deck?.created_at, false)}</div > <div className='w-10 h-10'>{causa ? <img style={estiloDoComponente} src={require('../../../assets/imagens/' + causa.causa + '.png')}></img> : null}</div></div>
					<div className='flex-1'></div>
					< div style={{ textShadow: '0px 0px 3px rgba(0, 0, 0, 1)' }} className='  font-bold' >{deck.nome}</div >
					<div>
						<img></img>
						<div>{usersList?.find(e => e.id == deck.user_id)?.nome}</div>
					</div>
					<div className='border-b border-slate-200 border-opacity-50'></div>
					< div className='flex mt-2 md:h-6 h-5' >
						{fortunas_finais ? fortunas_finais?.map(el => {
							return <img className=" md:w-6  w-5" style={(el.tipo == 'Ign' || el.tipo == 'Karma' || el.tipo == 'Verbus') ? estiloDoComponentFortunasquentes : estiloDoComponentFortunaslgidas} src={require('../../../assets/imagens/' + el.tipo.toLowerCase() + '.png')} ></img>
						}) : null}
					</div >
				</div>


			</div>
			{/* <img src={imgBG2} alt="Imagem" class="z-0 absolute top-[-63px] left-[-10px] object-cover  w-[200px] h-[570px] [clip-path:polygon(12%_11%,120%_11%,120%_50%,12%_50%)]"></img> */}


		</div >




	)
}

export default ItemListDeck